import React from 'react';
import { Button } from 'antd';
import './HowWeThinkWork.css';
import { ReactComponent as CareersIcon } from '../assets/icons/Duotone/Stack.svg';
import siteConfig from '../../configuration/siteConfiguration';
import { useIsMobile } from '../../hooks/useMediaQuery';


function HowWeThinkWork() {
  const isMobile = useIsMobile();
  const baseUrl = `${siteConfig.assetBaseUrl}/icons/careers/hero-section---how-we-think--work`;
  const valuesListContent = (<><div className="values-list">
    <div className="value-item">
      <div className="value-icon">
        <img src={`${baseUrl}/bold-thinking-grounded-execution.svg`} alt="Bold thinking, grounded execution icon" />
      </div>
      <div className="value-content">
        <h3>Bold thinking, grounded execution</h3>
        <p>We solve hard problems, not hypothetical ones</p>
      </div>
    </div>
    <div className="value-divider"></div><div className="value-item">
      <div className="value-icon">
        <img src={`${baseUrl}/radical-transparency.svg`} alt="Radical transparency icon" />
      </div>
      <div className="value-content">
        <h3>Radical transparency</h3>
        <p>No hidden agendas. No micro-management. We speak, share, and iterate openly</p>
      </div>
    </div>
    <div className="value-divider"></div>
    <div className="value-item">
      <div className="value-icon">
        <img src={`${baseUrl}/community-over-competition.svg`} alt="Community over competition icon" />
      </div>
      <div className="value-content">
        <h3>Community over competition</h3>
        <p>You'll never walk alone here. We back each other in standups and in life</p>
      </div>
    </div></div>
  </>);

  return (
    <div className="careers-page">
      <section className="how-we-think-work">
        <div className="hwtw-header-container">
          <div className="left-header">
            <p className="section-label">- HOW WE THINK & WORK</p>
            <h2>Shape the future of intelligent enterprises - and grow with It</h2>
            <div className="text-content">
              <p>
                At Cognitva, we don't believe in job descriptions - we believe in calling and craft.
                Whether you're an engineer, designer, researcher, or product thinker, you're here to
                build something that matters.
              </p>
              <p>
                We work as a team of equals - respecting all voices, lived experiences, and
                individual genius.
              </p>
            </div>
          </div>
          {!isMobile && valuesListContent}
        </div>
        {isMobile && valuesListContent}
      </section >
      <div className="cta-divider"></div>
      <div className="how-we-think-work-cta-container">
        <p className="cta-text-inline">
          We are digital-first but deeply human from daily check-ins to monthly all-hands where everyone's voice is heard
        </p>
        <Button
          type="primary"
          size="large"
          className="cta-button-inline"
          onClick={() => {
            const openRolesSection = document.getElementById('open-roles-section');
            if (openRolesSection) {
              openRolesSection.scrollIntoView({ behavior: 'smooth' });
            } else {
              window.location.href = '/careers#open-roles-section';
            }
          }}
        >
          See open roles
        </Button>
      </div>
    </div >
  );
}

export default HowWeThinkWork;